export const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  country: "",
  typeOfEnquiry: "",
  driveStyle: "",
  part: "",
  make: "",
  model: "",
  year: "",
  engine: "",
  extraFront: "",
  extraRear: "",
  message: "",
  privacy: false,
};
